module.exports = __webpack_public_path__ + "img/icon-sports-black.a6587684.svg";